import { render, staticRenderFns } from "./home-add-or-update.vue?vue&type=template&id=7c232d36&"
import script from "./home-add-or-update.vue?vue&type=script&lang=js&"
export * from "./home-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports